import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API,
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      const currentPath = window.location.pathname;
      
      // Only show message and logout if we're in a protected area
      if (currentPath.includes('company')) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
        
        toast.error('Sesiunea ta a expirat. Te rugăm să te autentifici din nou.');
        
        // Redirect to home after a short delay
        setTimeout(() => {
          const navigate = useNavigate();
          nagivate('/');
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
